import { render, staticRenderFns } from "./MoveRenewals.vue?vue&type=template&id=97385830&scoped=true"
import script from "./MoveRenewals.vue?vue&type=script&lang=js"
export * from "./MoveRenewals.vue?vue&type=script&lang=js"
import style0 from "./MoveRenewals.vue?vue&type=style&index=0&id=97385830&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97385830",
  null
  
)

export default component.exports